import theme from '@theme';
import React from 'react';
import styled from 'styled-components';

import { HeaderBadge } from '../order-details/types';
import DisplayActions from './DisplayActions';
import OrderHeaderBadges from './HeaderBadges';
import { Action } from './types';

interface DisplayHeaderProps {
  name: string | undefined;
  elements: HeaderBadge[];
  actions?: Action[];
}

const DisplayHeader: React.FC<DisplayHeaderProps> = ({ name, elements, actions }) => {
  return (
    <HeaderContainer>
      <InformationsHeader>
        <OrderName>{name}</OrderName>
        <OrderHeaderBadges badges={elements} />
      </InformationsHeader>
      <DisplayActions actions={actions} />
    </HeaderContainer>
  );
};

const OrderName = styled.span`
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  color: ${theme.palette.blue[500]};
`;

const InformationsHeader = styled.div`
  position: relative;
  height: 2.25rem;
  width: fit-content;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
`;

const HeaderContainer = styled.div`
  position: static;
  width: 100%;
  height: 3.75rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
`;

export default DisplayHeader;
